import React, { useState } from 'react';
import '../css/FAQSection.css';

const categories = [
  'All',
  'Bookings',
  'Payment',
  'Services & Cost',
];

const faqs = [
  {
    category: 'Bookings',
    question: 'How do I book a PG through your platform?',
    answer: 'You can book a PG by browsing listings, selecting a property, and paying the token amount to confirm your booking.',
  },
  {
    category: 'Bookings',
    question: 'Can I schedule a site visit before booking?',
    answer: 'Yes, we provide site visit options. You can schedule it through the platform or contact our support team.',
  },
  {
    category: 'Bookings',
    question: 'Is the token amount refundable if I cancel?',
    answer: 'The token amount is non-refundable unless the booking is canceled due to our inability to confirm the PG.',
  },

  {
    category: 'Payment',
    question: 'What options do I have for making payment?',
    answer: 'We have multiple payment options like Netbanking, UPI, Cash, NEFT, IMPS, and Wallets. We do not accept cheques or credit/debit cards.',
  },
  {
    category: 'Payment',
    question: 'How do I pay securely for my reservation?',
    answer: 'We use a secure payment gateway to protect your personal and payment information.',
  },
  {
    category: 'Payment',
    question: 'What do you mean by paying token amount?',
    answer: 'A token amount confirms your booking and temporarily reserves the property for you.',
  },

  {
    category: 'Services & Cost',
    question: 'Are utility charges included in the rent?',
    answer: 'No, electricity and other utility charges are usually separate unless mentioned otherwise in the listing.',
  },
  {
    category: 'Services & Cost',
    question: 'What services are included in the rent?',
    answer: 'Basic services include water supply, security, and maintenance. Some PGs also offer WiFi, meals, and laundry.',
  },
  {
    category: 'Services & Cost',
    question: 'Is there any brokerage or hidden charge?',
    answer: 'No, we operate on a no-brokerage model. All charges are clearly mentioned before payment.',
  }
];

const FAQSection = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [openIndex, setOpenIndex] = useState(null);

  const filteredFaqs =
    activeCategory === 'All'
      ? faqs
      : faqs.filter((faq) => faq.category === activeCategory);

  const toggleAnswer = (index) => {
    setOpenIndex(index === openIndex ? null : index); // toggle
  };

  return (
    <div className="faq-wrapper">
      {/* Banner */}
      <div className="faq-banner">
        <h1>FAQs</h1>
        <p>Need help? Explore our FAQs to find quick answers about bookings, payments, policies, and more.</p>
      </div>

      {/* Container */}
      <div className="faq-container">
        <div className="faq-header">FAQs</div>

        {/* Tabs */}
        <div className="faq-categories">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`faq-tab ${activeCategory === cat ? 'active' : ''}`}
              onClick={() => {
                setActiveCategory(cat);
                setOpenIndex(null); // close answer on tab change
              }}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* FAQ List */}
        <div className="faq-list">
          {filteredFaqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? 'open' : ''}`}
              onClick={() => toggleAnswer(index)}
            >
              <div className="faq-question-row">
                <span className="plus-icon">{openIndex === index ? '-' : '+'}</span>
                <span className="faq-question">{faq.question}</span>
              </div>
              {openIndex === index && (
  <div className="faq-answer">
    {faq.answer}
  </div>
)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQSection;